import ActionType from "../../Actions/ActionType";
import { userAction } from "../../Actions/UserModule/userAction";

const intialState = {
  filterData: {},
  selectedRoles: [],
};

const user = (state: object = intialState, action: userAction) => {
  switch (action.type) {
    case ActionType.SET_USER_FILTER:
      return {
        ...state,
        filterData: action.data,
      };
    case ActionType.SET_USER_ROLE_FILTER:
      return {
        ...state,
        selectedRoles: action.roles,
      };
    default:
      return state;
  }
};
export default user;
